
import React, {Component} from 'react';
import PrintPreview from './PrintPreview'
import ReportPOAndExpense from '../report/ReportPOAndExpense'
import ReportStore from '../../stores/ReportStore';
import Moment from 'moment';
import Chart from 'chart.js';
import { findDOMNode } from 'react-dom'

class PrintReportPOAndExpense extends Component {

  constructor(...args){
    super(...args)
    
    if (this.props.typePrint==='chart') {
      var all_day = Moment(this.props.year+'-'+this.props.month, "YYYY-MM").daysInMonth()
    } else {
      var all_day = Moment().daysInMonth()
    }

    const optionsDay = []
    for (var i=0;i<=all_day;i++) {
      if (i == 0) {
        var label = 'ทั้งเดือน'
      } else {
        var label = i
      }
      optionsDay.push({
        value: i,
        label: label
      })
    }

    this.state = {loading:false,data:[],dataFormat:[],check_date:[],optionsDay:optionsDay}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());


    let page = 'portrait'
    if (this.props.typePrint==='chart')
      page = 'landscape'

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size(page);
  }

  componentDidMount(){
    let {year,month,day} = this.props
    this.loadPoAndExpense(year,month,day)
  }

  loadPoAndExpense(year='', month='', day='') {
    let that = this
    let {data,check_date,dataFormat} = this.state
    let doc_no = []
    let supplier_name = []
    let amount = []
    let sum_amount = 0
    that.setState({loading:true})
    ReportStore.loadReportPoAndExpense(year, month, day, '', '', function(result) {
      that.setState({data:[], dataFormat:[], check_date:[]})

      for (var i=0;i<result.data.length;i++) {
        if (check_date.indexOf(result.data[i].doc_date)==-1) {
          check_date.push(result.data[i].doc_date)
        }
      }

      for (var i=0;i<check_date.length;i++) {
        for (var j=0;j<result.data.length;j++) {
          if (check_date[i]==result.data[j].doc_date) {
            doc_no.push(result.data[j].doc_no)
            supplier_name.push(result.data[j].supplier_name)
            amount.push(result.data[j].amount)
            sum_amount = parseInt(sum_amount) + parseInt(result.data[j].amount)
          }
        }
        dataFormat.push({
          doc_date: check_date[i],
          meta: {
            doc_no: doc_no,
            supplier_name: supplier_name,
            amount: amount
          },
          sum_amount: sum_amount
        })
        doc_no = []
        supplier_name = []
        amount = []
        sum_amount = 0
      }

      that.setState({data:dataFormat,dataFormat:[],loading:false})
      if (that.props.typePrint==='chart') {
        that.setBarChart()
      }
    })  
  }

  setBarChart() { 
    this.canvasBar = findDOMNode(this.canvasBarRef);
    this.ctxBar = this.canvasBar.getContext('2d');
    let canvasBar = this.canvasBar,ctxBar=this.ctxBar
    let {data,optionsDay} = this.state
    let {month} = this.props
    let labels = []
    let data_barchart = []
    let data_year = [0,0,0,0,0,0,0,0,0,0,0,0]
    let data_month = []
    if (month=="0") {
      let i = 0
      let January = 'มกราคม'
      let February = 'กุมภาพันธ์'
      let March = 'มีนาคม'
      let April = 'เมษายน'
      let May = 'พฤษภาคม'
      let June = 'มิถุนายน'
      let July = 'กรกฎาคม'
      let August = 'สิงหาคม'
      let September = 'กันยายน'
      let October = 'ตุลาคม'
      let November = 'พฤศจิกายน'
      let December = 'ธันวาคม'
      labels = [January,February,March,April,May,June,July,August,September,October,November,December]
      data.forEach(element => {
        let month = ""
        month = element.doc_date.substring(5, 7)
        month = parseInt(month) - 1
        data_year[month] = parseFloat(data_year[month]) + parseFloat(element.sum_amount)
        i++
      })
      data_barchart = data_year
    } else {
      for(var i=0;i<optionsDay.length-1;i++) {
        data_month[i] = 0
        labels[i] = i+1
      }
      let i = 0
      data.forEach(element => {
        let day = ""
        day = element.doc_date.substring(8, 10)
        day = parseInt(day) - 1
        data_month[day] = parseFloat(data_month[day]) + parseFloat(element.sum_amount)
        i++
      })
      data_barchart = data_month
    }
    if(this.barChart!=null){
      this.barChart.destroy();
    }
    this.barChart = new Chart(ctxBar, {
      type: 'bar',
      data: {
          labels: labels,
          datasets: [{
              label: 'รายจ่าย',
              data: data_barchart,
              backgroundColor: '#d2d6de'
          }]
      },
      options: {
          scales: {
              yAxes: [{
                  ticks: {
                      beginAtZero:true
                  }
              }]
          }
      }
    });
  }

  renderComponentPage(newData,sum_all_day,checkLast,index) {
    return (
      <div className='font-print' key={index}>
        <header style={{float:'none',textAlign:'center'}}>
          <h2 className="text-center">{'ตารางรายงานสรุปรายจ่าย'}</h2>
        </header>
        <br/>
        <div>
          {this.renderTable(newData,sum_all_day,checkLast)}
        </div>
      </div>
    )    
  }

  renderTable(newData,sum_all_day,checkLast) {
    return(
      <table className="table table-responsive table-report-po-print">
        <thead>
          <tr>
            <th style={{width:"90px"}}>เลขที่เอกสาร</th>
            <th style={{width:"300px"}}>ชื่อผู้ขาย</th>
            <th style={{width:"90px"}}></th>
            <th style={{width:"90px"}} className="text-right">มูลค่ารวม</th>
            <th style={{width:"90px"}} className="text-right">ภาษี</th>
            <th style={{width:"90px"}} className="text-right">รวมทั้งสิ้น</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData(newData,sum_all_day,checkLast)}
        </tbody>
      </table>
    )
  }

  renderDocDate(date) {
    return(
      <div className="bd-date"><b>{date}</b></div>
    )
  }

  renderCol(datas,key,status=true) {
    return(
      datas.map((data, index) => {
        return(
          <div key={index} className={datas.length-1===index&&key==='amount'?'bd-sum':''}>
            {status?data:<br/>}
          </div>
        )
      })
    )
  }

  renderRowData(newData,sum_all_day,checkLast) {

    if (newData.length===0||newData===undefined) {
      return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        newData.map((item,index) => {
          let check_last = 'none'
          if (checkLast&&newData.length-1===index) {
            check_last = ''
          }

          return(
            <tr key={index}>
              <td>
                {this.renderDocDate(item.doc_date)}
                {this.renderCol(item.meta.doc_no,'doc_no')}
              </td>
              <td>
                <div className="bd-date"><br/></div>
                {this.renderCol(item.meta.supplier_name,'supplier_name')}
              </td> 
              <td className="text-center">
                <div className="bd-date"><br/></div>
                {this.renderCol(item.meta.amount,'amount',false)}
                <div className="bd-sum text-left"><b>รวม/วัน</b></div>  
                <div style={{display:check_last}} className="bd-sum text-left"><b>ยอดรวมสุทธิ</b></div>
              </td>
              <td className="text-right">
                <div className="bd-date"><br/></div>
                {this.renderCol(item.meta.amount,'amount')}
                <div className="bd-sum">{item.sum_amount}</div> 
                <div style={{display:check_last}} className="bd-sum"><br/></div> 
              </td>
              <td className="text-right">
                <div className="bd-date"><br/></div>
                {this.renderCol(item.meta.amount,'amount')}
                <div className="bd-sum">0.00</div>  
                <div style={{display:check_last}} className="bd-sum"><br/></div>
              </td>
              <td className="text-right">
                <div className="bd-date"><br/></div>
                {this.renderCol(item.meta.amount,'amount')}
                <div className="bd-sum">{item.sum_amount}</div>  
                <div style={{display:check_last}} className="bd-sum"><b>{sum_all_day}</b></div>
              </td>
            </tr>
          )
        })
      )
    }
  }

  setData(data,length,round,sum_all_day,curData='') {
    let {loading} = this.state
    let allData = []
    if (curData!==''&&curData.length>0) {
      allData = curData
    }
    let newData = []
    let balData = []
    let checkRow = 0
    let checkFirstOver = true
    data.forEach(function(item,index) {
      let row = 0
      row = parseInt(item.meta.doc_no.length) + parseInt(2)
      if (parseInt(checkRow)+parseInt(row)<=40) {
        checkRow += parseInt(row)
        newData.push(item)
        if (length===round||(length===1&&round===0)) {
          allData.push(newData)
        }
      } else {
        if (checkFirstOver===true) {
          allData.push(newData)
          checkFirstOver = false
        }
        balData.push(item)
      }
      round++
    })
    if (balData.length>0) {
      return this.setData(balData,length,round,sum_all_day,allData)
    } else {
      return(
        <PrintPreview 
          loading={loading} 
          leftBarTitle={'ตารางรายงานสรุปรายจ่าย'}
          size={this.props.typePrint==='chart'?'landscape':'portrait'}
        >  
          {
            allData.map((item,index) => {
              let checkLast = false
              if (allData.length-1===index) {
                checkLast = true
              }
              return(
                this.renderComponentPage(item,sum_all_day,checkLast,index)
              )
            })
          }
        </PrintPreview>
      )
    }
  }

  renderBarChat() {
    let {loading} = this.state
    return(
      <PrintPreview 
        loading={loading} 
        leftBarTitle={'ตารางรายงานสรุปรายจ่าย'}
        size={this.props.typePrint==='chart'?'landscape':'portrait'}
      >
        <div className='font-print'>
          <header style={{float:'none',textAlign:'center'}}>
            <h2 className="text-center">{'ตารางรายงานสรุปรายจ่าย'}</h2>
          </header>
          <br/>
          <canvas 
            ref={(canvasBar) => { this.canvasBarRef = canvasBar; }}>
          </canvas>
        </div>
      </PrintPreview>
    )
  }

  render(){
    let {loading,data} = this.state
    let sum_all_day = 0

    data.forEach(function(item,index) {
      sum_all_day += parseInt(item.sum_amount)
    })

    if (this.props.typePrint==='chart') {
      return(
        <div>{this.renderBarChat()}</div>
      )
    } else {
      if (data.length>0&&data!==undefined) {
        return this.setData(data,data.length,0,sum_all_day)  
      } else {
        return(
          <PrintPreview 
            loading={loading} 
            leftBarTitle={'ตารางรายงานสรุปรายจ่าย'}
            size={this.props.typePrint==='chart'?'landscape':'portrait'}
          >
            <div className='font-print'>
              <header style={{float:'none',textAlign:'center'}}>
                <h2 className="text-center">{'ไม่พบข้อมูล'}</h2>
              </header>
            </div>
          </PrintPreview>
        )
      }
    }  
  }
}

PrintReportPOAndExpense.defaultProps = {
  title: '',  
  mode : '',
  workNo : ''
}
export default PrintReportPOAndExpense;


// WEBPACK FOOTER //
// ./src/view/print/PrintReportPOAndExpense.js